import { Text } from "@vagastec/ensemble-core";
import {
  button,
  circle,
  ul,
  divider,
  stepLabel,
  buttonVariant,
  circleVariant,
  dividerVariant,
} from "./steps.css";

export const Steps = ({
  items = [],
  selectedId,
  onSelectedIdChange = () => {},
}) => {
  return items.length ? (
    <ul className={ul}>
      {items.map((item, index) => (
        <Steps.Item
          key={item.id}
          id={item.id}
          label={item.label}
          index={index}
          onSelect={() => onSelectedIdChange(item.id)}
          isSelected={index <= items.findIndex((v) => v.id === selectedId)}
          isBarActive={index <= items.findIndex((v) => v.id === selectedId) - 1}
          items={items}
        />
      ))}
    </ul>
  ) : null;
};

Steps.Item = ({
  id,
  index,
  label,
  onSelect = () => {},
  isSelected = false,
  isBarActive = false,
  items = [],
}) => {
  // const handleClick = () => {
  //   // if (isSelected) return;
  //   onSelect(id);
  // };

  return (
    <>
      <li>
        {/* <button */}
        <div
          className={`${button} ${
            buttonVariant[isSelected ? "selected" : "base"]
          }`}
          // onClick={handleClick}
        >
          <span
            className={`${circle} ${
              circleVariant[isSelected ? "selected" : "base"]
            }`}
          >
            {id}
          </span>
          <span className={stepLabel}>
            <Text size="sm">{label}</Text>
          </span>
        </div>
        {/* </button> */}
      </li>
      {index < items.length - 1 ? (
        <div
          className={`${divider} ${
            dividerVariant[isBarActive ? "active" : "base"]
          }`}
        />
      ) : null}
    </>
  );
};

Steps.Item.displayName = "Steps.Item";
